import { render, staticRenderFns } from "./MenuPainelGerente.vue?vue&type=template&id=fd689788&"
import script from "./MenuPainelGerente.vue?vue&type=script&lang=js&"
export * from "./MenuPainelGerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports